export default __webpack_public_path__ + "static/media/vortex.00257a46.webp";